import QuestionsSkeleton from './QuestionsSkeleton';

export default QuestionsSkeleton;
